import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/ADD_VOUCHER';
export const {action: show} = createAction(`${domain}/SHOW`, (institutionId, billPayerId, recurringPaymentId) => ({
    institutionId,
    billPayerId,
    recurringPaymentId,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {
    action: search,
    success: searchSuccess,
    failed: searchFailed,
} = createAction(`${domain}/SEARCH`, (institutionId, term) => ({institutionId, term}));

export const {
    action: save,
    success: saveSuccess,
    failed: saveFailed,
} = createAction(`${domain}/SAVE`, (institutionId, billPayerId, {voucherCompany, payment}) => ({
    institutionId,
    billPayerId,
    voucherCompany,
    payment,
}));

export const {
    action: deletePayment,
    success: deletePaymentSuccess,
    failed: deletePaymentFailed,
    aborted: deletePaymentAborted,
} = createAction(`${domain}/DELETE_PAYMENT`, (institutionId, billPayerId, recurringPaymentId) => ({
    institutionId,
    billPayerId,
    recurringPaymentId,
}));
